// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gpFJ2","comment":"styles_comment__1S4PF"};